module.exports = __webpack_public_path__ + "img/250612-06-7.a94b6d49.png";